import { render } from "./About.vue?vue&type=template&id=f3d0b0f6&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=f3d0b0f6&lang=scss&scoped=true"

import exportComponent from "/Users/songlian/Developer/官網/配音工會/taipei-sound-recording/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d0b0f6"]])

export default __exports__